import { render, staticRenderFns } from "./_creditsElement.vue?vue&type=template&id=34910cc8&"
import script from "./_creditsElement.vue?vue&type=script&lang=js&"
export * from "./_creditsElement.vue?vue&type=script&lang=js&"
import style0 from "./_creditsElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports